import { render, staticRenderFns } from "./TaxPayerDetail.vue?vue&type=template&id=37e02658&"
import script from "./TaxPayerDetail.vue?vue&type=script&lang=js&"
export * from "./TaxPayerDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports